<div class="h-100 single-report-page">
    <app-admin-report [columns]="timePeriodReports" [hasFilters]="true" [apiUrl]="timePeriodReportsAPI"
                      reportTitle="ADMINISTRATION.TIME_PERIOD_PACKAGES_ADMINISTRATIVE_REPORT_TITLE">
        <ng-template>
            <!--todo user filter to be added here-->
        </ng-template>
    </app-admin-report>
</div>